import { watch } from 'vue'

import { useHealthCheckStore } from '../stores/healthCheckStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Health-check findings are workspace-scoped rows; the expanded/collapsed category chrome and
 *  the open drawer only describe the list they were opened over, so both edges clear everything.
 *  `useHealthChecks` re-fetches on its own account/workspace watch while the page is mounted —
 *  this covers the far commoner case where it is not. */
export function registerHealthChecksLifecycle(): () => void {
  const store = useHealthCheckStore()
  const { workspaceId } = useWorkspace()
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) store.resetState()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(() => store.resetState())
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
